export const secureFileSharingIntroSteps = [
  {
    element: 'h3',
    intro: 'Secure Data Sharing is where you can safely upload and share files- such as student or user data lists- with the WordFlight Customer Support team.'
  },
  {
    element: '.upload-container',
    intro: 'Click here to upload a file. Then select your file from your device and click Open. Your file will upload and appear in the Secure Data Sharing list.'
  }
];